import {renderMarkRule, renderNodeRule} from 'datocms-structured-text-to-plain-text'
import {isLink, isParagraph} from 'datocms-structured-text-utils'
import {Fragment} from 'react'
import {StructuredText} from 'react-datocms/structured-text'
import {DatoConstant} from '~/cms/components/Constants/DatoConstant'
import DisclaimerLink from '~/cms/components/SingleLineStructuredText/DisclaimerLink'
import {handleDropCapMark} from '../../../_blog/ArticleWYSIWYG/_utils/markRules'
import {
  handleBoldMark,
  handleCodeMark,
  handleIOMark,
  handleSuperscriptMark,
} from '../../_utils/markRules'
import {handleLinkNode} from '../../_utils/nodeRules'
import {type WysiwygSingleLineStructuredTextFragment} from './_generated/fragment.graphql'

type WYSIWYGSingleLineStructuredTextProps = {
  data?: WysiwygSingleLineStructuredTextFragment | null
}

export function WYSIWYGSingleLineStructuredText({
  data,
}: WYSIWYGSingleLineStructuredTextProps) {
  if (!data) return null
  return (
    <Fragment key={data.id}>
      <StructuredText
        customMarkRules={[
          renderMarkRule('code', handleCodeMark),
          renderMarkRule('drop-cap', handleDropCapMark),
          renderMarkRule('io-font', handleIOMark),
          renderMarkRule('strong', handleBoldMark),
          renderMarkRule('superscript', handleSuperscriptMark),
        ]}
        customNodeRules={[
          renderNodeRule(isLink, handleLinkNode),
          renderNodeRule(isParagraph, ({children, key}) => {
            return <span key={key}>{children}</span>
          }),
        ]}
        renderLinkToRecord={({record}) => {
          switch (record.__typename) {
            case 'ConstantRecord':
              return <DatoConstant data={record} />
            case 'DisclaimerRecord':
              return <DisclaimerLink {...record} text={record.text} />
            default:
              return null
          }
        }}
        data={data.text}
      />
    </Fragment>
  )
}
